import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "block w-full" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4 w-full mb-5" }
const _hoisted_3 = { class: "inputTitle" }
const _hoisted_4 = { class: "inputField flex-grow" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "error-msg" }
const _hoisted_7 = { class: "grid grid-cols-1 gap-4 w-full" }
const _hoisted_8 = { class: "inputTitle" }
const _hoisted_9 = { class: "inputField flex-grow" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "error-msg" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_13 = { class: "mb-4" }
const _hoisted_14 = { class: "inputField flex-grow" }
const _hoisted_15 = { class: "float-left" }
const _hoisted_16 = { class: "float-right" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear-both" }, null, -1)

import {computed, onBeforeUnmount, onMounted, reactive, ref, toRef} from "vue";
import {BryntumGrid} from "@bryntum/grid-vue-3";
import {type Grid, Store} from "@bryntum/grid";
import {useGlobalStore} from "@/stores/GlobalStore";
import GridInputFilter from "@/components/GridInputFilter";
import {useI18n} from "vue-i18n";
import {helpers, required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import {ErrorLocationType, TableType} from "@/utilities/enums/Enums";
import {LocationService} from "@/utilities/services/entities/LocationService";
import {checkboxColumnConfig} from "@/AppConfig";



export default /*#__PURE__*/_defineComponent({
  __name: 'SafetyInstructionsPopup',
  props: {
  data: Object
},
  setup(__props) {

const props = __props

const gridStore = new Store();
const globalStore = useGlobalStore();
const { t } = useI18n();
const locationService = new LocationService();

const selectedLocations = ref([]);



const grid = ref<Grid | null>(null);
const useGridConfig = {
  headerMenuFeature: false,
  enableTextSelection: true,
  selectionMode : {
    row	  : true,
    checkbox: checkboxColumnConfig,
    showCheckAll : true,
    deselectFilteredOutRecords: true
  },
  height: "400px",
  columns : {
    data: [
      {
        id: 'name',
        field : 'name',
        text: t('popups.locations.name'),
        flex   : 1,
        sortable: true
      },
      {
        id: 'typeLevel',
        field : 'typeLevel',
        text: t('popups.activitySet.group2'),
        flex   : 1,
        sortable: true
      },
      {
        id: 'group1Name',
        field : 'netzCenter',
        text: t('popups.activitySet.group1'),
        flex   : 1,
        sortable: true
      },
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await globalStore.saveUserColumnOrder(TableType[TableType.safetyInstruction], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  listeners: {
    selectionChange(event) {
      if(event.selection.length > 0 && event.selection[0]?.data === undefined) return;
      selectedLocations.value = selectedLocations.value.concat(event.selected.map(lr => lr.data))
      selectedLocations.value = selectedLocations.value.filter(l => !event.deselected.map(lr => lr.data).includes(l));
      popupData.value.safetyInstructionLocations = selectedLocations.value;
    }
  },
}
const gridConfig = reactive(useGridConfig);

const setGridData = async ()=>{
  const locations = await locationService.getLocations("selectable", ErrorLocationType.popup);

  gridStore.setStoreData(locations);

  // set selected locations in table
  grid.value.instance.value.selectRows(popupData.value.safetyInstructionLocations.map(l => l.id))

  globalStore.reorderColumns(TableType[TableType.safetyInstruction]);
}

const popupData = toRef(props, 'data');

onMounted(async () => {
  globalStore.setGridStore(ref(gridStore));
  globalStore.setGridColumnStore(ref(grid.value?.instance.value?.columns));
  globalStore.modal.validator = v$;

  await setGridData();
})

onBeforeUnmount(()=>{
  globalStore.setGridStore(null);
  globalStore.setGridColumnStore(null);

  globalStore.currentItems = 0;
  globalStore.allItems = 0;
});


// Validation

const rules = computed(() => {
  const rules = {
    name: { required: helpers.withMessage(t('validators.required'), required) },
    text: { required: helpers.withMessage(t('validators.required'), required) },
  }
  return rules
})

const v$ = ref(useVuelidate(rules, popupData))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('safetyInstructions.name')) + " * ", 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.name.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(popupData).name) = $event)),
                class: "w-full"
              }, null, 512), [
                [_vModelText, _unref(popupData).name]
              ]),
              _hoisted_5,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.name.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('safetyInstructions.description')) + " * ", 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.text.$errors.length })
            }, [
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control w-full",
                type: "text",
                rows: "4",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(popupData).text) = $event))
              }, null, 512), [
                [_vModelText, _unref(popupData).text]
              ]),
              _createTextVNode(),
              _hoisted_10,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.text.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _hoisted_12,
        _createElementVNode("div", null, [
          _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.$t('safetyInstructions.safetyInstructionLocations')), 1),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(selectedLocations.value.length) + " " + _toDisplayString(_ctx.$t('safetyInstructions.selectedLocationsCount')), 1),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_unref(GridInputFilter), {
                gridStore: _unref(gridStore),
                hideFilterButton: true
              }, null, 8, ["gridStore"])
            ]),
            _hoisted_17,
            _createVNode(_unref(BryntumGrid), _mergeProps({
              ref_key: "grid",
              ref: grid
            }, gridConfig, { readOnly: true }), null, 16)
          ])
        ])
      ])
    ])
  ]))
}
}

})